export default __webpack_public_path__ + "static/media/Roboto-LightItalic.a46c187b.woff";